'use client';
import { FC, useEffect, useRef, useState } from 'react';

type Props = {
  url: {
    webm: string;
    mov: string;
  };
  className?: string;
  /** Infinite looping. Superseed the loops and onComplete props */
  infinite?: boolean;
  loops?: number;
  onComplete?: () => void;
};

export const AnimationVideo: FC<Props> = ({ url, className, infinite, loops = 1, onComplete }) => {
  const ref = useRef<HTMLVideoElement>(null);
  const [loopsRemaining, setLoopsRemaining] = useState<number>(loops);

  useEffect(() => {
    // Realty return if infinite is true
    if (infinite) {
      return;
    }

    let mounted = true;
    const currentVideo = ref.current;

    const handleEnded = () => {
      if (mounted && currentVideo) {
        if (loopsRemaining > 1) {
          setLoopsRemaining(loopsRemaining - 1);
          currentVideo.currentTime = 0;
          currentVideo.play();
        } else {
          onComplete?.();
        }
      }
    };

    if (currentVideo) {
      currentVideo.addEventListener('ended', handleEnded);
    }
    return () => {
      mounted = false;
      if (currentVideo) {
        currentVideo.removeEventListener('ended', handleEnded);
      }
    };
  }, [infinite, loopsRemaining, onComplete]);

  return (
    <video ref={ref} className={className} loop={infinite} autoPlay muted playsInline controls={false}>
      <source src={url.mov} type="video/mp4;codecs=hvc1" />
      <source src={url.webm} type="video/webm" />
    </video>
  );
};
